export const MASTER = {
    get: "/master",
    serverTime: "/server-time"
  };
  